import { EffectCallback, useEffect } from 'react';

const useMountEffect = (mountEffect: EffectCallback) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(mountEffect, []);
};

export default useMountEffect;
